module.exports = __webpack_public_path__ + "1597c5f9dd46bb0d68b9480092ec05f7.MP3";